import React, { useState } from 'react';

const FaqPage = () => {
  const faqItems = [
    {
      question: "¿Cómo elijo el tamaño de acuario adecuado?",
      answer: "El tamaño del acuario depende de la cantidad y tipo de peces que desees tener. Como regla general, se recomienda al menos 1 litro de agua por cada centímetro de pez adulto. Para principiantes, un acuario de 20-30 litros es un buen punto de partida."
    },
    {
      question: "¿Con qué frecuencia debo cambiar el agua de mi acuario?",
      answer: "Se recomienda cambiar entre el 25% y el 30% del agua del acuario cada una o dos semanas. Esto ayuda a mantener la calidad del agua y a eliminar los nitratos acumulados."
    },
    {
      question: "¿Qué tipo de filtro necesito para mi acuario?",
      answer: "Existen varios tipos de filtros (de cascada, internos, externos). La elección depende del tamaño de tu acuario y de la carga biológica (cantidad de peces). Un filtro de cascada es ideal para acuarios pequeños a medianos."
    },
    {
      question: "¿Puedo mezclar diferentes tipos de peces en el mismo acuario?",
      answer: "Sí, pero debes investigar la compatibilidad de las especies. Algunos peces son territoriales o tienen requisitos de agua muy diferentes. Es crucial elegir peces con temperamentos y necesidades similares para evitar problemas."
    },
    {
      question: "¿Cómo sé si mis peces están sanos?",
      answer: "Los peces sanos son activos, tienen colores vibrantes, aletas extendidas y comen con apetito. Si notas cambios en su comportamiento, color, o si tienen manchas o aletas pegadas, podría ser un signo de enfermedad."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-background min-h-screen p-4 sm:p-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-8 sm:mb-10 text-center">Preguntas Frecuentes</h1>
      <div className="container mx-auto max-w-3xl">
        {faqItems.map((item, index) => (
          <div key={index} className="bg-card rounded-2xl shadow-lg mb-4 overflow-hidden">
            <button
              className="w-full flex justify-between items-center p-4 sm:p-6 text-left text-lg sm:text-xl font-semibold text-textPrimary focus:outline-none"
              onClick={() => toggleAnswer(index)}
            >
              {item.question}
              <svg
                className={`w-6 h-6 transform transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                openIndex === index ? 'max-h-screen opacity-100 p-4 sm:p-6 pt-0' : 'max-h-0 opacity-0'
              }`}
            >
              <p className="text-textSecondary text-base sm:text-lg leading-relaxed">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;